import { useTheme } from '@mui/material/styles';
import { Backdrop, CircularProgress } from '@mui/material';
import React from 'react'

export interface BusySpinnerProps extends React.HTMLAttributes<HTMLDivElement> {
  busy: boolean;
}

const BusySpinner = ({ busy, children, ...other }) => {
  const theme = useTheme();

  return (
    <div {...other} style={{ position: 'relative', height: '100%', width: '100%' }} >
      <Backdrop
        data-testid="busy-spinner-overlay"
        sx={{
          zIndex: theme.zIndex.drawer + 1,
          color: '#fff',
          position: 'absolute'
        }}
        open={busy}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      {children}
    </div>
  )
}

export default BusySpinner;
